<template>
  <div>
    <div>
      <div class="nav">
        <div
          @click="$router.push({ path: '/msgpage', query: { type: 1 } })"
          style="position:relative"
        >
          <img src="../../assets/msg/dz.png" alt="" />
          <span class="num" v-if="allNum.fabulousNum != 0 && iconShow">{{
            allNum.fabulousNum
          }}</span>
        </div>
        <div
          @click="$router.push({ path: '/msgpage', query: { type: 2 } })"
          style="position:relative"
        >
          <img src="../../assets/msg/pl.png" alt="" />
          <span class="num" v-if="allNum.commentNum != 0 && iconShow">{{
            allNum.commentNum
          }}</span>
        </div>
        <div
          @click="$router.push({ path: '/msgpage', query: { type: 0 } })"
          style="position:relative"
        >
          <img src="../../assets/msg/tz.png" alt="" />
          <span class="num" v-if="allNum.systemNum != 0 && iconShow">{{
            allNum.systemNum
          }}</span>
        </div>
      </div>
      <div class="t-list" v-if="user && user.is_teacher == 1 && tList.length != 0">
        <div v-for="(item,index) in tList" :key="index" class="t-item" @click="changeTeacher(item.id,index)">
          <span class="num" v-if="item.num">{{item.num}}</span>
          <img :src="item.avatar">
        </div>
      </div>
    </div>

    <list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <swipe-cell v-for="(item, index) in list" :key="index">
        <div class="reply" @click="chat(item)">
          <div class="reply-img">
            <van-image
              fit="cover"
              width="100%"
              height="100%"
              :src="item.avatar"
              alt=""
            />
          </div>
          <div class="reply-r">
            <div class="reply-t">
              <div class="reply-name">{{ item.username }}</div>
              <div class="reply-time">{{ item.updated_time }}</div>
            </div>
            <div class="reply-msg">
              <p v-html="item.new_msg" style="min-height:23px"></p>
              <!-- <span>12</span> -->
              <badge
                v-if="(user.is_teacher == 1 ? item.see_num : item.see_num) > 0"
                :content="user.is_teacher == 1 ? item.see_num : item.see_num"
                max="99"
              />
            </div>
          </div>
        </div>
        <template
          #right
          v-if="item.type == 0 || (item.type == 1 && user.service == 1)"
        >
          <button class="del-reply" @click="replyClose(item, index)">
            <i class="iconfont icon-lajitong"></i>
          </button>
        </template>
      </swipe-cell>
    </list>
  </div>
</template>

<script>
/**
@description:
@createTime:2021-08-12
@create:wq
*/
import { SwipeCell, Badge ,List} from "vant";
import { shareJsSdk, SOHERF } from "@/utils/tool";
export default {
  name: "msg",
  props: {},
  components: { SwipeCell, Badge ,List},
  data() {
    return {
      list: [],
      user: {},
      delIndx: 0,
      allNum: {},
      user: JSON.parse(localStorage.getItem("user")),
      iconShow: false,
      socketFlag: this.$store.getters.socketFlag,
      f: 0,
      loading: false,
      finished: false,
      page:1,
      size:9,
      tList:[],
      roomId:[],
      getTlist:false
    };
  },
  computed: {},
  watch: {
    "$store.state.app.socketFlag": {
      handler: function(newVal) {
        this.socketFlag = newVal;
        if (newVal == 1) {
          this.sendSoMsg();
        }
      },
      deep: true,
    },
  },
  mounted() {},
  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.iconShow = false;
    this.roomId = [];
    this.list = [];
    this.sendSoMsg();
    if (this.user) {
      this.msgPageNum();
      this.getNum();
    }
    shareJsSdk("msg", "可以测", "国学传统文化 在线一对一咨询平台");
  },
  methods: {
    onLoad(){
      if(this.page == 1){
        return
      }
      this.open();
    },
    sendSoMsg() {
      let num = 0;
      // this.Toast(this.socket.readyState+'9')
      const I = setInterval(() => {
        // this.Toast(this.socket.readyState)
        console.log(this.socket.readyState, "------------readyState--------");
        if (this.socket.readyState == 1) {
          this.f = 0;
          if (this.list.length == 0) {
            this.socket.send(
              JSON.stringify({
                action: "bindUid",
                api_token: localStorage.getItem("token"),
              })
            );
          }
          setTimeout(() => {
            this.open();
            this.getTeacherList()
          }, 200);
          this.socket.onmessage = this.getMessage;
          clearInterval(I);
        } else {
          num++;
          if (num >= 10) {
            clearInterval(I);
          }
          this.resocket();
        }
      }, 500);
    },
    resocket() {
      this.socket = new WebSocket(SOHERF);
      this.socket.onopen = this.onopen();
    },
    onopen() {
      if (localStorage.getItem("token")) {
        this.socket.send(
          JSON.stringify({
            action: "bindUid",
            api_token: localStorage.getItem("token"),
          })
        );
        setTimeout(() => {
          this.sendSoMsg();
        }, 200);
      }
    },
    getNum() {
      this.api.msgNumAll().then((res) => {
        this.allNum = res.data;
        this.iconShow = true;
      });
    },
    msgPageNum() {
      this.api.msgPageNum().then((res) => {
        this.$store.dispatch("app/setNum", res.data.msgPageNum);
      });
    },
    replyClose(item, index) {
      // console.log(item, localStorage.getItem("token"));
      let msg = {
        action: "delRoom",
        api_token: localStorage.getItem("token"),
        roomId: item.id,
      };

      if (this.socket) {
        this.socket.send(JSON.stringify(msg));
        this.delIndx = index;
      }
    },
    chat(item) {
      // console.log(item);
      // `/pages/users/msg/chat?id=${item.id}&oid=${item.oid}&s=${item.status}&t=${item.oStatus}&remind=${item.remind}`
      let obj = {
        id: item.id,
        oid: item.oid,
        s: item.roomStatus,
        t: item.status,
        // remind: item.remind,
      }
      if(this.user.is_teacher == 1){
        obj.tid = item.tid;
      }
      
      this.$router.push({
        path: item.type == 0 ? "chat" : "SERVECHAT",
        query: obj,
      });
    },
    open() {
      // console.log("open");
      // this.Toast('11')
      this.f++;
      this.socket.send(
        JSON.stringify({
          action: "roomList",
          page:this.page,
          size:this.size,
          api_token: localStorage.getItem("token"),
        })
      );
    },
    //获取老师列表
    getTeacherList(){
      this.getTlist = true;
      this.socket.send(
        JSON.stringify({
          action: "getTeacherList",
          api_token: localStorage.getItem("token"),
        })
      );
    },
    //切换老师
    changeTeacher(id,index,t=0){
      if(index == 0 && t!=1) return
      this.page = 1;
      this.roomId = [];
      this.socket.send(
        JSON.stringify({
          action: "changeTeacher",
          api_token: localStorage.getItem("token"),
          tid:id
        })
      );
    },
    error(err) {
      console.log("=====err=====");
      console.log(err);
      console.log("=====err=====");
    },
    getMessage(msg) {
      /* *
      * 0：失败
      * 1：发送消息
      * 2：消息列表
      * 3：房间列表
      * 4：消息发送成功
      * 5：删除房间成功
      * 6：退款成功
      * 7：系统消息
      * 8：订单结束
      * 9：订单结束成功
      * 20：获取全部老师列表
      * 21：切换老师成功
      * */
      const data = JSON.parse(msg.data);
      if (data.code == 3) {
        // console.log(this.page,'----page');
        let l = data.data;
        // if(this.page == 1){
        //   this.list = data.data;
        // }else{
        //   this.list = [...this.list,...data.data];
        // }
        let arr = [];
        if(this.roomId.length == 0){
          this.list = data.data;
          l.map(r => {
            arr.push(r.id);
          })
          this.roomId = arr;
        }else{
          // console.log(this.roomId,'this.roomId');
          l.map(r => {
            let key = this.roomId.indexOf(r.id)
            if(key >= 0){
              this.list[key] = r;
            }else{
              this.list.push(r);
              this.roomId.push(r.id)
            }
          })
        }

        if (data.data.length < this.size) {
          this.loading = true;
          this.finished = true;
        } else {
          this.loading = false;
        }
        this.page ++;
        // console.log(this.list);
        // this.list.map((r) => {
        //   if (r.new_msg.indexOf("<img") >= 0) {
        //     r.new_msg = "[表情信息]";
        //   }
        // });
        
        for (let i in this.list) {
          if (this.list[i].new_msg.indexOf("<img") >= 0) {
            this.list[i].new_msg = "[表情信息]";
          }
        }
      } else if (data.code == 5) {
        this.list.splice(this.delIndx, 1);
      } else if (data.code == 401) {
        if (this.f >= 5) {
          return;
        }
        this.open();
        this.getTeacherList()
      }else if(data.code == 20){
        let arr=[];
        if(data.data.thisTeacher){
          arr = [data.data.thisTeacher]
        }
        this.tList = [...arr,...data.data.list];
        if(!data.data.thisTeacher && this.getTlist){
          this.getTlist = false;
          this.changeTeacher(this.tList[0].id,0,1)
        }
      }else if(data.code == 1){
        // this.page = 1;
        this.msgPageNum();
        // let id = data.data.roomId;
        // let isindex = 0;
        // this.list.map((r,inx) => {
        //   if(r.id == id){
        //     this.list[inx].new_msg = data.data.title;
        //     this.list[inx].see_num = this.list[inx].see_num *1 + 1;
        //     isindex ++;
        //     this.$forceUpdate()
        //   }
        // })
        // if(isindex == 0){
        //   let obj = data.data;
        //   obj.id = data.data.roomId;
        //   obj.new_msg = data.data.title;
        //   obj.see_num = 1
        //   this.list.unshift(obj)
        // }
        

      }
      // this.Toast(data.code)
      // console.log(JSON.parse(msg.data));
    },
    sendSocket() {
      if (this.socket) {
        this.socket.send(JSON.stringify({}));
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.nav {
  display: flex;
  > div {
    flex: 1;
    img {
      width: 100%;
    }
  }
}
.t-list{
  display: flex;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  padding: 0 .27rem;
  box-sizing: border-box;
  margin-bottom: .43rem;
  margin-top: .2rem;
  .t-item{
    padding: .05rem;
    position: relative;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    flex-shrink: 0;
    margin-right: .25rem;
    &:last-child{
      margin-right: 0;
    }
    &:first-child{
      margin-right: .53rem;
      border: 1px solid #3DDD81;
      &::after{
        content: ' ';
        height: .64rem;
        width: 2px;
        background: #eee;
        top: 50%;
        transform: translateY(-50%);
        right: -.29rem;
        position: absolute;
      }
    }
    img{
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    span{
      position: absolute;
      width: .3rem;
      height: .3rem;
      background: #F9647D;
      color: #fff;
      border-radius: 50%;
      border: 1px solid #fff;
      right: 0;
      z-index: 2;
      font-size: .2rem;
    }
  }
  
}
.num {
  position: absolute;
  right: 0.2rem;
  top: 0.05rem;
  width: 0.3rem;
  height: 0.3rem;
  border-radius: 50%;
  background: #f9647d;
  color: #fff;
  line-height: 0.3rem;
  font-size: 0.09rem;
  border: 1px solid #fff;
  text-align: center;
}

.reply {
  padding: 0 0.22rem;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  // height: 1.28rem;
  .reply-img {
    width: 0.98rem;
    height: 0.98rem;
    overflow: hidden;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.26rem;
    img {
      width: 100%;
    }
  }
  .reply-r {
    flex: 1;
    border-bottom: 1px solid #ddd;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0.24rem 0;
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .reply-name {
      font-size: 0.3rem;
      font-weight: bold;
      color: #333333;
    }
    .reply-time {
      font-size: 0.24rem;
      font-weight: 500;
      color: #999999;
    }
    .reply-msg {
      p {
        font-size: 0.24rem;
        color: #999999;
        display: inline-block;
        width: 4rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
.del-reply {
  width: 1.2rem;
  height: 100%;
  background-color: #f9647d;
  border: none;
  i {
    color: #ffffff;
  }
}
</style>
